import { requestWithToken } from '../utilities/request';

const path = '/api/private/fields';

// 一覧
const list = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_groups/list`),
    params: param,
  });
};

// 新規登録
const create = (fieldId, param) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`/${fieldId}/field_groups`),
    params: param,
  });
};

// 編集
const update = (fieldId, id, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${fieldId}/field_groups/${id}`),
    data: param,
  });
};

// 並び替え
const updateOrder = (fieldId, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${fieldId}/field_groups/update_order`),
    data: param,
  });
};

// 削除
const del = (fieldId, id) => {
  return requestWithToken({
    method: 'DELETE',
    url: path.concat(`/${fieldId}/field_groups/${id}`),
  });
};

// TODO: Gatesのものなのであとでなおす
// const listForGatePassages = (fieldId, param) => {
//   return requestWithToken({
//     method: 'GET',
//     url: path.concat(`/${fieldId}/gates/list_for_gate_passages`),
//     // url: path.concat(`/${fieldId}/field_groups/list_for_gate_passages`),
//     params: param,
//   });
// };

// 編集時の一件表示
const show = (fieldId, id) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_groups/${id}`),
  });
};

export const GroupSettingService = {
  list,
  create,
  update,
  updateOrder,
  del,
  // listForGatePassages,
  show,
};

export default GroupSettingService;



// WEBPACK FOOTER //
// ./src/services/GroupSetting.js